// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"936":"1946cb279d9db73d","1221":"2f8daefc5b589185","3602":"b032542b00a85812","4937":"3f9be707632950ba"}[chunkId] + ".css";
};